import React from 'react';
import style from './Activity.css';

const PlanUpdatedEvent = (props) => {
  return <span>Plan updated to <span className={style.capitalize}>{props.plan}</span> by {props.userEmail}</span>;
};

export default PlanUpdatedEvent;
